module.exports = __webpack_public_path__ + "2.4ea4bbeac27efc0fef69.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/johnn/Documents/things/innovajsl/src/assets/images/bg/2.jpg
// module id = ../../../../../src/assets/images/bg/2.jpg
// module chunks = styles